import { authPost } from './authMiddleware';

export const postCompanyCities = (data) => {
    return authPost(`/api/company/city?CountryName=${data}`);
}